import { FETCH_USER, CREATE_USER } from './../constants';
import { handleActions } from "redux-actions"

export const user  = handleActions(
  {
    [ FETCH_USER ]: (state, action) => {
      let dataReturn = {}
      if (action.payload.name !=='error') {
        dataReturn = action.payload
      }
      if (action.payload.error) {
        dataReturn = state
      } else {
        dataReturn = action.payload.data
      }
      return dataReturn
    },
    [ CREATE_USER ]: (state, action) => state
  }, {}
)